import apiClient from 'services/api';

type JoinWaitlistPayload = {
  name: string;
  email: string;
  phone?: string;
  whatsapp?: string;
  profession?: string;
  how_clients_find_you?: string;
  biggest_challenge?: string;
};

export const joinWaitlist = (data: JoinWaitlistPayload) =>
  apiClient.post<{ message: string; position: number }>(
    '/public/waitlist',
    data,
  );

export const getWaitlistCount = () =>
  apiClient.get<{ count: number }>('/public/waitlist/count');
